import type { MessageDescriptor } from 'react-intl';
import { defineMessage } from 'react-intl';
import { SubscriptionPlanCode } from '@_/constants';

export interface PlanContent {
  code: string;
  description: MessageDescriptor;
  features: MessageDescriptor[];
  featured?: boolean;
}

export const planContents: PlanContent[] = [
  {
    code: SubscriptionPlanCode.Basic,
    description: defineMessage({
      id: 'component:subscription.basic-plan-description',
      defaultMessage: 'Start for free with the essentials to get your business online and visible.'
    }),
    features: [
      defineMessage({
        id: 'component:subscription.feature.respond-to-reviews',
        defaultMessage: 'Respond to customer reviews'
      }),
      defineMessage({
        id: 'component:subscription.feature.customize-venue-listing',
        defaultMessage: 'Customize venue listing details and upload photos'
      })
    ]
  },
  {
    code: SubscriptionPlanCode.Advanced,
    description: defineMessage({
      id: 'component:subscription.advanced-plan-description',
      defaultMessage: 'Tailored for expanding businesses that need professional-grade tools.'
    }),
    features: [
      defineMessage({
        id: 'component:subscription.feature.everything-in-basic',
        defaultMessage: 'Everything in Basic'
      }),
      defineMessage({
        id: 'component:subscription.feature.10-permanent-venues',
        defaultMessage: '10 permanent venues'
      }),
      defineMessage({
        id: 'component:subscription.feature.online-offline-classes',
        defaultMessage: 'Online and offline class schedule'
      }),
      defineMessage({
        id: 'component:subscription.feature.book-classes-online',
        defaultMessage: 'Book classes online'
      }),
      defineMessage({
        id: 'component:subscription.feature.class-waitlist-tools',
        defaultMessage: 'Class waiting list tools'
      }),
      defineMessage({
        id: 'component:subscription.feature.maintain-customer-relationships',
        defaultMessage: 'Maintain customer relationships'
      }),
      defineMessage({
        id: 'component:subscription.feature.marketing-tools',
        defaultMessage: 'Marketing tools'
      })
    ],
    featured: true
  }
] as const;
